import COLORS from '@/resources/Colors';

enum MediaSource {
    CAMERA = 1,
    MICROPHONE = 2,
}

type MediaMachineType = {
    id: string;
    url: string;
    displayName: string;
    source: MediaSource;
    icons: string[];
    color: COLORS;
    published: boolean;
    recommendedClasses: string[][];
    supportsMiniMediaMachine: boolean;
};

export const MediaMachineTypes: Record<string, MediaMachineType> = {
    beeld: {
        id: 'beeld',
        url: 'beeld',
        displayName: 'Beelden herkennen',
        source: MediaSource.CAMERA,
        icons: [require('./assets/Apple.svg'), require('./assets/Banana.svg')],
        color: COLORS.PRIMARY,
        published: true,
        recommendedClasses: [
            ['🧒 ik', '👦 jij'],
            ['🍎 appel', '🍌 banaan'],
            ['⬆️ omhoog', '⬇️ omlaag'],
            ['⬅️ links', '➡️ rechts'],
            ['🧒 ik', '😺 kat'],
        ],
        supportsMiniMediaMachine: true,
    },
    gebaren: {
        id: 'gebaren',
        url: 'gebaren',
        displayName: 'Gebaren herkennen',
        source: MediaSource.CAMERA,
        icons: [
            require('./assets/Gesture1.svg'),
            require('./assets/Gesture2.svg'),
        ],
        color: COLORS.SECONDARY,
        published: true,
        recommendedClasses: [
            ['✊ boks', '✋ hallo'],
            ['👍 goed', '👎 slecht'],
            ['✋ links', '🤚 rechts'],
            ['🖐️ dicht', '🖖 open'],
            ['✌️ vrede', '🤙 bellen'],
        ],
        supportsMiniMediaMachine: false,
    },
} as const;
